import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "sensorsMain-actions" }
const _hoisted_2 = { class: "sensorsMain-actions-buttons" }
const _hoisted_3 = { class: "sensorsMain-actions-stamp" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = {
  key: 0,
  class: "sensorsMain"
}
const _hoisted_7 = { class: "sensorsMain-container-general" }
const _hoisted_8 = { class: "sensorsMain-left-column" }
const _hoisted_9 = { class: "sensorsMain-sensor" }
const _hoisted_10 = {
  key: 0,
  class: "title"
}
const _hoisted_11 = {
  key: 1,
  class: "value"
}
const _hoisted_12 = { class: "sensorsMain-sensor-info" }
const _hoisted_13 = { class: "title" }
const _hoisted_14 = { class: "value" }
const _hoisted_15 = { class: "sensorsMain-sensor-info" }
const _hoisted_16 = { class: "title" }
const _hoisted_17 = { class: "value" }
const _hoisted_18 = {
  key: 0,
  class: "sensorsMain-sensor-info"
}
const _hoisted_19 = { class: "title" }
const _hoisted_20 = { class: "value sensorsMain-sensor-color" }
const _hoisted_21 = { class: "sensorsMain-buttons" }
const _hoisted_22 = {
  key: 0,
  class: "sensorsMain-diagram"
}
const _hoisted_23 = { class: "sensorsMain-container-alarmsTable" }
const _hoisted_24 = { class: "sensorsMain-container-alarmsTable__title" }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = {
  key: 1,
  class: "no-alarms-message"
}
const _hoisted_27 = {
  key: 1,
  class: "sensorsMain"
}
const _hoisted_28 = { class: "sensorsMain-container-general" }
const _hoisted_29 = { class: "sensorsMain-left-column" }
const _hoisted_30 = { class: "sensorsMain-sensor" }
const _hoisted_31 = { class: "title" }
const _hoisted_32 = { class: "value" }
const _hoisted_33 = {
  key: 0,
  class: "sensorsMain-sensor-info"
}
const _hoisted_34 = { class: "title" }
const _hoisted_35 = { class: "sensorsMain-diagram" }
const _hoisted_36 = { class: "sensorsMain-container-alarmsTable" }
const _hoisted_37 = { class: "sensorsMain-container-alarmsTable__title" }
const _hoisted_38 = { key: 0 }
const _hoisted_39 = {
  key: 1,
  class: "no-alarms-message"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_LineChart = _resolveComponent("LineChart")!
  const _component_Table = _resolveComponent("Table")!
  const _component_EditSensor = _resolveComponent("EditSensor")!
  const _component_AddComment = _resolveComponent("AddComment")!
  const _component_AddSensorAlarmComment = _resolveComponent("AddSensorAlarmComment")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.dataLineChart)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 0,
              class: "download-pdf-button",
              variant: "bordered",
              title: _ctx.$t('downloadTempPDF'),
              onClick: _ctx.generatePDF
            }, null, 8, ["title", "onClick"]))
          : _createCommentVNode("", true),
        (_ctx.dataLineChart && !_ctx.isGroupView && _ctx.selectedSensorsData?.[0])
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 1,
              class: "downloadStamps-button",
              variant: "bordered",
              title: _ctx.$t('downloadCheckStamps'),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.downloadSensorCheckStamps(_ctx.selectedSensorsData[0])))
            }, null, 8, ["title"]))
          : _createCommentVNode("", true),
        (_ctx.isGroupView && _ctx.pharmacy)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 2,
              class: "downloadAllStamps-button",
              variant: "bordered",
              title: _ctx.$t('downloadAllCheckStamps'),
              onClick: _ctx.downloadAllCheckStamps
            }, null, 8, ["title", "onClick"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_3, [
          (_ctx.normalizedStamp && !_ctx.isGroupView)
            ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.$t('lastCheckedBy')) + " " + _toDisplayString(_ctx.normalizedStamp.userName) + " " + _toDisplayString(_ctx.formatTimestamp(_ctx.normalizedStamp.timestamp)), 1))
            : _createCommentVNode("", true),
          (_ctx.allSensorsCheckInfo)
            ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.allSensorsCheckInfo.text), 1))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    (!_ctx.isGroupView)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedSensorsData, (el) => {
            return (_openBlock(), _createElementBlock("div", {
              key: el.id,
              class: "sensorsMain-container"
            }, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.infoAboutSersor, (item, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: "sensorsMain-sensor-info"
                      }, [
                        (el[item.value])
                          ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(item.label), 1))
                          : _createCommentVNode("", true),
                        (el[item.value])
                          ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(el[item.value]), 1))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128)),
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.$t('lastTemperature') || 'Last Temp'), 1),
                      _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.getLastTempIndividual(el.sn)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.$t('sensorType')), 1),
                      _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.$t(el.type || 'individual')), 1)
                    ]),
                    (el.color)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                          _createElementVNode("p", _hoisted_19, _toDisplayString(_ctx.$t('colorLabel')), 1),
                          _createElementVNode("span", _hoisted_20, [
                            _createElementVNode("span", {
                              class: "sensorsMain-sensor-color__swatch",
                              style: _normalizeStyle({ backgroundColor: el.color })
                            }, null, 4),
                            _createTextVNode(" " + _toDisplayString(el.color), 1)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _createVNode(_component_Button, {
                      class: "editSensor-button",
                      variant: "filled",
                      title: _ctx.$t('editSensor'),
                      onClick: ($event: any) => (_ctx.initEditSensor(el.id))
                    }, null, 8, ["title", "onClick"])
                  ])
                ]),
                (_ctx.chartDataById(el.sn)?.labels?.length && _ctx.isDateCorrect)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                      (_openBlock(), _createBlock(_component_LineChart, {
                        id: 'lineChart_' + el.sn,
                        key: _ctx.lineChartKey,
                        "data-line-chart": _ctx.chartDataById(el.sn),
                        "options-line-chart": _ctx.chartOptionsWithLegend,
                        style: _normalizeStyle(_ctx.styleLineChart)
                      }, null, 8, ["id", "data-line-chart", "options-line-chart", "style"]))
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  (_ctx.tableDataById(el.id)?.length && _ctx.isDateCorrect)
                    ? (_openBlock(), _createBlock(_component_Button, {
                        key: 0,
                        class: "downloadAlarms-button",
                        variant: "bordered",
                        title: _ctx.$t('downloadAlarms') || 'Download alarms',
                        onClick: ($event: any) => (_ctx.downloadAlarmsPdf(_ctx.tableDataById(el.id), _ctx.columnsById, el.name || el.sn))
                      }, null, 8, ["title", "onClick"]))
                    : _createCommentVNode("", true),
                  _createElementVNode("p", null, _toDisplayString(_ctx.$t('deviationsInTimeFrame')), 1)
                ]),
                (_ctx.tableDataById(el.id)?.length && _ctx.isDateCorrect)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                      _createVNode(_component_Table, {
                        data: _ctx.tableDataById(el.id),
                        columns: _ctx.columnsById,
                        onCommentSensorAlarm: _ctx.openCommentModal,
                        onCommentSensorAlarmBulk: _ctx.openBulkCommentModal
                      }, null, 8, ["data", "columns", "onCommentSensorAlarm", "onCommentSensorAlarmBulk"])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_26, [
                      _createElementVNode("p", null, _toDisplayString(_ctx.$t('noAlarms') || 'No alarms found for this period'), 1)
                    ]))
              ])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (_ctx.isGroupView && _ctx.isDateCorrect)
      ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("div", _hoisted_30, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allSensorsLastTemps, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "sensorsMain-sensor-info"
                  }, [
                    _createElementVNode("p", _hoisted_31, _toDisplayString(item.id), 1),
                    _createElementVNode("span", _hoisted_32, _toDisplayString(item.temp), 1)
                  ]))
                }), 128)),
                (!_ctx.allSensorsLastTemps.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                      _createElementVNode("p", _hoisted_34, _toDisplayString(_ctx.$t('loading')) + "...", 1)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_35, [
              (_openBlock(), _createBlock(_component_LineChart, {
                id: 'lineChart',
                key: _ctx.lineChartKey,
                "data-line-chart": _ctx.processedAllChartData,
                "options-line-chart": _ctx.chartOptionsWithLegend,
                style: _normalizeStyle(_ctx.styleLineChart)
              }, null, 8, ["data-line-chart", "options-line-chart", "style"]))
            ])
          ]),
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("div", _hoisted_37, [
              (_ctx.transformedAlarmsSensor?.length && _ctx.isDateCorrect)
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 0,
                    class: "downloadAlarms-button",
                    variant: "bordered",
                    title: _ctx.$t('downloadAlarms') || 'Download alarms',
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.downloadAlarmsPdf(_ctx.transformedAlarmsSensor, _ctx.columns, _ctx.selectedOption?.[0]?.label)))
                  }, null, 8, ["title"]))
                : _createCommentVNode("", true),
              _createElementVNode("p", null, _toDisplayString(_ctx.$t('deviationsInTimeFrame')), 1)
            ]),
            (_ctx.transformedAlarmsSensor?.length && _ctx.isDateCorrect)
              ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                  _createVNode(_component_Table, {
                    data: _ctx.transformedAlarmsSensor,
                    columns: _ctx.columns,
                    onCommentSensorAlarm: _ctx.openCommentModal,
                    onCommentSensorAlarmBulk: _ctx.openBulkCommentModal
                  }, null, 8, ["data", "columns", "onCommentSensorAlarm", "onCommentSensorAlarmBulk"])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_39, [
                  _createElementVNode("p", null, _toDisplayString(_ctx.$t('noAlarms') || 'No alarms found for this period'), 1)
                ]))
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_EditSensor, {
      "edit-sensor-data": _ctx.editSensorData,
      "pharmacy-id": _ctx.pharmacy?.id,
      "show-modal-edit-sensor": _ctx.showModalEditSensor,
      onCloseModal: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showModalEditSensor = false))
    }, null, 8, ["edit-sensor-data", "pharmacy-id", "show-modal-edit-sensor"]),
    _createVNode(_component_AddComment, {
      "edit-sensor-data": _ctx.editSensorData,
      "pharmacy-id": _ctx.pharmacy?.id,
      "show-modal-add-comment": _ctx.showModalAddComment,
      onCloseModal: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showModalAddComment = false))
    }, null, 8, ["edit-sensor-data", "pharmacy-id", "show-modal-add-comment"]),
    _createVNode(_component_AddSensorAlarmComment, {
      "show-modal": _ctx.showSensorAlarmCommentModal,
      "active-alarm": _ctx.activeAlarm,
      loading: _ctx.commentLoading,
      onCloseModal: _ctx.closeCommentModal,
      onSaveComment: _ctx.saveComment
    }, null, 8, ["show-modal", "active-alarm", "loading", "onCloseModal", "onSaveComment"])
  ], 64))
}